import { defineAsyncComponent } from 'vue'
export default {
  order: defineAsyncComponent(() => import("/vercel/path0/apps/bitbelicash/layouts/order.vue").then(m => m.default || m)),
  compact: defineAsyncComponent(() => import("/vercel/path0/layers/components/fubex-components/layouts/compact.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/vercel/path0/layers/components/fubex-components/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/vercel/path0/layers/components/fubex-components/layouts/empty.vue").then(m => m.default || m))
}